var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-tooltip', { staticClass: "res-custom-tool", attrs: { "effect": "dark", "content": _vm.tipsContent, "placement": "top" } }, [_c('pt-button', { staticStyle: { "width": "20px", "height": "20px", "padding": "4px", "display": "block" }, attrs: { "type": _vm.PtButtonType.Ghost, "icon": "", "theme": _vm.PtButtonTheme.Primary, "size": _vm.PtButtonSize.Small }, on: { "click": function click($event) {
        $event.stopPropagation();$event.preventDefault();return _vm.handleClick.apply(null, arguments);
      } } }, [_c('pt-icon', [_c('ic-sameasset')], 1)], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };